import React, { useState, useEffect, useCallback } from "react";
import './../../App.css';
import './Transactions.css';
import axios from 'axios';
import {token, domain, globalTimeFormat} from './../Security';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {SetAuditTrail} from './../Reports/AuditTrailReportEmployeeSetup';
import loadingSpinner from './../../assets/loading.gif';
import {useTable, useSortBy} from 'react-table';
// icon
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import CloseIcon from "@mui/icons-material/Close";
import ChecklistIcon from '@mui/icons-material/Checklist';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

function MobileDTRApproval({user, userAccess, isHideSideMenu}) {
    var uploadTimeEntriesHeader = [
        " ",
        "Employee Id",
        "Employee",
        "Date",
        "Time In",
        "Time Out",
        "Location",
        "Status",
        "Image",
    ]
    var uploadTimeEntriesaccessor = [
        "selection",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "date",
        "timeIn",
        "timeOut",
        "gpsLocation",
        "status",
        "image",
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [dateTimeRecordData, setDateTimeRecordData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("description");

    const [isSelectAll, setIsSelectAll] = useState(false);
    const [activeRowIds, setActiveRowIds] = useState([]); // Array to store active row IDs
    const [selected, setSelected] = useState([]); // Array to store active row IDs

    const triggerSelectAll = () => {
        if(dateTimeRecordData.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Wait for the requests to load.")
            return;
        }
        setIsSelectAll(true);
    }
    const unselectAll = () => {
        setSelected([]);
        setActiveRowIds([]);
        setIsSelectAll(false);
    }

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const apiUrl =  domain + "/api/MobileEmployeeTimeRecordStaging";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + `/approver/${user.employeePersonalInformationId}/days/${15}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            setDateTimeRecordData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl, user]);

    const fetchDataHR = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + `/admin/days/${15}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            setDateTimeRecordData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    const fetchDataById = useCallback(async (data) => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + `/${data.id}/employee/${data.employeePersonalInformationId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return response.data
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);

            return null;
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        const fetch = async () => {
            if(userAccess.description === "HR Head"
            || userAccess.description === "HR Assistant"
            || userAccess.description === "HR Assistant2"
            || userAccess.description === "HR Assistant3"
            || userAccess.description === "HR Manager"
            ){
                await fetchDataHR();
            } else {
                await fetchData();
            }
        };

        fetch()
    }, [fetchData, fetchDataHR, userAccess])

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeePersonalInformationEmployeeId.toLowerCase().includes(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setDateTimeRecordData(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("employee name")
                break;
            case 1:
                setSearchPlaceholder("employee id")
                break;
            default:
                setSearchPlaceholder("employee name")
                break;
        }
        const fetch = async () => {
            if(userAccess.description === "HR Head"
            || userAccess.description === "HR Assistant"
            || userAccess.description === "HR Assistant2"
            || userAccess.description === "HR Assistant3"
            || userAccess.description === "HR Manager"
            ){
                await fetchDataHR();
            } else {
                await fetchData();
            }
        };

        fetch()
        
    }, [filterDataIndex, fetchData, fetchDataHR, userAccess]);

    const [showApproveConfirmation, setShowApproveConfirmation] = useState(false);
    const openMassApproveConfirmation = () => {
        if(selected.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please select DTR.");
            return;
        }
        setShowApproveConfirmation(true);
    }
    const closeMassApproveConfirmation = () => {
        setShowApproveConfirmation(false);
    }

    /* const handleDelete = async () => {
        const apiUrl = domain + "/api/MobileEmployeeTimeRecordStaging/bulk-delete";
        try {
            await axios.post(apiUrl, selected, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
        } catch (error) {
            console.error('Error:', error);
        }
    } */

    const handleApprove = async () => {
        const filteredSelected = selected.filter(i => i.status !== "Approved");
        if(filteredSelected.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage('No "Pending" status in your selected data.');
            return;
        }

        const apiUrl = domain + "/api/MobileEmployeeTimeRecord/bulk";
        setLoadingRequest(true);

        const data = selected
            .filter(i => i.status !== "Approved")
            .map(i => ({
                employeePersonalInformationId: i.employeePersonalInformationId,
                date: i.date,
                timeIn: i.timeIn,
                timeOut: i.timeOut,
                createdById: i.createdById,
                createdDate: i.createdDate,
                gpsLocation: i.gpsLocation,
                image: i.image,
                approverId: user.employeePersonalInformationId,
                approvedDate: new Date(),
            }));

        try {
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await SetAuditTrail({
                setupArea: "Mobile DTR Approval", 
                actionTaken: "approve", 
                field: "Approve DTR", 
                newValue: "[bulk data]", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            // await handleDelete();

            if(userAccess.description === "HR Head"
            || userAccess.description === "HR Assistant"
            || userAccess.description === "HR Assistant2"
            || userAccess.description === "HR Assistant3"
            || userAccess.description === "HR Manager"
            ){
                await fetchDataHR();
            } else {
                await fetchData();
            }
            
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        unselectAll();
        closeMassApproveConfirmation();
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="TransactionInfo shadow-xl">
                        <div className="transaction-header">
                        <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Mobile DTR Approval"}</span>
                        </div>
                            <h3>Mobile DTR Approval</h3>
                        </div>
                        <div className="transaction-body">
                            <>
                                {Filter(setFilterDataIndex)}
                                <div className="mainte-body-top row">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e) => handleFilter(e.target.value), 
                                                                    "Search by " + searchPlaceholder, 
                                                                    SearchIcon)}
                                </div>
                                <div className='body-top-btn mass-approval-btn row' style={{padding: "5px 0"/* , display: "none" */}}>
                                    <div style={{margin: "5px"}}>
                                        {CreateButton("", "select-all row", triggerSelectAll, "SELECT ALL", ChecklistIcon)}
                                    </div>
                                    <div style={{margin: "5px"}}>
                                        {CreateButton("", "approve row", openMassApproveConfirmation, "APPROVE", ThumbUpIcon)}
                                    </div>
                                </div>
                                <div className="transaction-table container">
                                    <CreateTable
                                        dataList={dateTimeRecordData}
                                        dataHeader={uploadTimeEntriesHeader}
                                        dataAccessor={uploadTimeEntriesaccessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        fetchDataById={fetchDataById}

                                        setSelected={setSelected}
                                        isSelectAll={isSelectAll}
                                        setIsSelectAll={setIsSelectAll}
                                        activeRowIds={activeRowIds}
                                        setActiveRowIds={setActiveRowIds}
                                    />
                                    {dateTimeRecordData.length > 0 ? (
                                        <div></div>
                                    )
                                    :
                                    (
                                        <div>
                                        {loading ? (
                                            <div
                                                style={{
                                                position: "fixed",
                                                top: "0",
                                                left: "0",
                                                width: "100vw",
                                                height: "100vh",
                                                zIndex: "2000",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center",
                                                backgroundColor: "#ffffff59",
                                                }}
                                            >
                                                <img src={loadingSpinner} alt="Loading..." />
                                            </div>
                                        ) : (
                                                <div> {/*<p>No records to display</p>*/}</div>
                                            )
                                        }
                                        </div>
                                    )}
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </div>
            <ApproveConfirmationForm isOpen={showApproveConfirmation} onClose={closeMassApproveConfirmation} handleApprove={handleApprove}/>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "5000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], approveHandleClick, disapproveHandleClick, currentPage, setCurrentPage, fetchDataById,
    setSelected, isSelectAll, setIsSelectAll, activeRowIds, setActiveRowIds,
}) {
    const itemsPerPage = 10;

    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [imageSource, setImageSource] = useState("");

    const openImage = async (data) => {
        const _data = await fetchDataById(data)
        const value = _data.image;

        const imageSrc = 'data:image/jpeg;base64,' + value;

        setImageSource(imageSrc);
        setIsImageModalOpen(true); // Open image in full view
    };
    
    const closeImageModal = () => {
        setIsImageModalOpen(false); // Close full image modal
    };

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    const handleRowClick = (rowData) => {
        setSelected(prevSelected => {
            const isAlreadySelected = prevSelected.some(item => item.id === rowData.id);
            return isAlreadySelected
                ? prevSelected.filter(item => item.id !== rowData.id)  // Remove rowData if already selected
                : [...prevSelected, rowData];                         // Add rowData if not selected
        });
        setActiveRowIds(prevIds => 
            prevIds.includes(rowData.id) 
            ? prevIds.filter(id => id !== rowData.id)  // Remove the row ID if it is already active
            : [...prevIds, rowData.id]                 // Add the new row ID if it is not already active
        );
    };

    useEffect(()=>{
        if(isSelectAll){
            const newActiveRowIds = rows.map(item => item.original.id);
            const newActiveRowOriginal = rows.map(item => item.original);
            setActiveRowIds(newActiveRowIds);
            setSelected(newActiveRowOriginal);
            setIsSelectAll(false);
        }
    }, [isSelectAll, setIsSelectAll, setSelected, rows, setActiveRowIds])

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    /* const handleRowClick = (rowData) => {
        setSelected(rowData); // Pass the clicked row data to the setSelectedEmployee function
        setActiveRowId(rowData.id);
    }; */

    return (
        <>
            <div>
                <div className='scrollable-table'>
                    <table {...getTableProps()} className='border-collapse'>
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            {...column.getHeaderProps()}
                                            onClick={() => headerClick(column)}
                                            className="sortable-header"
                                        >
                                            {`${column.render("Header")} ${
                                                sortHeaderValue.id === column.id
                                                    ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                    : ""
                                            }`}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {dataList.length <= 0 &&
                                <tr>
                                    <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                        No data to display
                                    </td>
                                </tr>
                            }
                            {currentItems.map((row) => {
                                prepareRow(row)
                                return (
                                    <tr key={row.original.id}
                                    {...row.getRowProps()} // Attach onClick event handler to the row
                                    onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                                    className={activeRowIds?.includes(row.original.id) ? 'active' : ''} // Check if row ID is in the array
                                    >
                                        {row.cells.map((cell) => (
                                            <SetInfo header={cell.render("Cell").props.column.Header} 
                                                _cell={cell}
                                                approveHandleClick={approveHandleClick}
                                                disapproveHandleClick={disapproveHandleClick}
                                                openImage={openImage}
                                                isActive={activeRowIds?.includes(row.original.id)}
                                            />
                                        ))}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                {rows.length > itemsPerPage ? (
                <div>
                    <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                        <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                                style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                            &lt;&lt;
                        </button>
                        <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                                style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                            <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                        </button>
                        <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                            style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                            NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                        </button>
                        <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                            style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                            &gt;&gt;
                        </button>
                    </div>
                    {`${currentPage}/${totalPages}`}
                </div>
                ) :
                <></>}
            </div>
            {/* Full Image Modal */}
            {isImageModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={closeImageModal} // Click outside to close
                >
                    <img
                        src={imageSource}
                        alt="Full view"
                        style={{ maxWidth: "90%", maxHeight: "90%" }}
                    />
                </div>
            )}
        </>
    )
}
function SetInfo({header, _cell, approveHandleClick, disapproveHandleClick, openImage, isActive}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === " ") {
        let isSelected = isActive;
        
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={isSelected}
                />
            </td>
        )
    }

    if (header === "Image") {
        return(
            <>
                <td>
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        <Tooltip text="View">
                            <div style={{padding:"0 5px"}} onClick={()=>openImage(data)}><RemoveRedEyeIcon/></div>
                        </Tooltip>
                    </div>
                </td>
            </>
        )
    }

    if (header === "Status") {
        return(
            <>
                <td
                style={{
                    background: value === "Approved" ? "#226d0d" : "",
                    color: value === "Approved" ? "white" : ""
                }}
                >
                {value === "Approved" ? (
                    <>
                    {value}
                    <br />
                    {data.approverFullName ? `${data.approverFullName}` : ""}
                    
                    <br />
                    {data?.approvedDate ? ` (${data?.approvedDate.split("T")[0]})` : ""}
                    </>
                ) : (
                    value
                )}
                </td>
            </>
        )
    }

    if (header === "Location") {
        if (value) {
            const googleMapsUrl = `https://www.google.com/maps?q=${value}`;
            return (
                <>
                    <td>
                        <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
                            View Location
                        </a>
                    </td>
                </>
            );
        }
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        let time = _cell.render("Cell").props.value;

        if(!time) {
            return (
                <td>
                    -
                </td>
            );
        }

        time = ConvertForTimeLocal(time, header);

        let timeParts;
        const timeSplit = time.split('T');
        if (timeSplit.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
        } else {
            timeParts = [];
        }
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];

        // Convert 24-hour format to 12-hour format and determine AM or PM
        const amPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

        const formattedTime = `${hours}:${minutes} ${amPm}`;

        return (
            <td>
                {formattedTime}
            </td>
        );
    }

    if (header === "Request Date") {
    
    const value = _cell.render("Cell").props.value;
    if (!value) {
      return <td>-</td>;
    }

    let date;
    let timeSource;

    if (String(value).includes("T")) {
      // ISO date-time, e.g. 2026-10-23T14:30:00
      date = new Date(value);
      timeSource = date;
    } else if (String(value).includes(":")) {
      // Time only, e.g. 14:30
      date = new Date();

      const [hours, minutes] = String(value)
        .split(":")
        .map((part) => parseInt(part, 10));

      if (
        Number.isNaN(hours) ||
        Number.isNaN(minutes) ||
        hours < 0 ||
        hours > 23 ||
        minutes < 0 ||
        minutes > 59
      ) {
        return <td>-</td>;
      }

      timeSource = new Date();
      timeSource.setHours(hours, minutes, 0, 0);
    } else {
      // Date only
      date = new Date(value);
      timeSource = null;
    }

    if (Number.isNaN(date.getTime())) {
      return <td>-</td>;
    }

    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    let formattedTime = "";

    if (timeSource) {
      const hours = timeSource.getHours();
      const minutes = String(timeSource.getMinutes()).padStart(2, "0");

      if (globalTimeFormat === "Standard Time") {
        const standardHours = hours % 12 || 12;
        const amPm = hours >= 12 ? "PM" : "AM";

        formattedTime = `${standardHours}:${minutes} ${amPm}`;
      } else if (globalTimeFormat === "Military Time") {
        formattedTime = `${String(hours).padStart(2, "0")}:${minutes}`;
      }
    }

    return (
      <td>
        {formattedDate}
        {formattedTime && ` ${formattedTime}`}
      </td>
    );
  }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    ){
        let date = new Date(_cell.render("Cell").props.value);

        if(!date) {
            return (
                <td>
                </td>
            );
        }

        date = ConvertForDateLocal(data.date, header);


        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "Employee Name":
                setFilterDataIndex(0);
                break;
            case "Employee Id":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="Employee Name">Employee Name</option>
                <option value="Employee Id">Employee Id</option>
            </select>
        </div>
    );
};
const ConvertForDateLocal = (dateString) => {
    // console.log("dateString", dateString);

    if (!dateString) {
        console.log("Invalid or empty date string");
        return null;
    }

    const dateTimeParts = dateString.split('T');
    if (dateTimeParts.length !== 2) {
        console.log("Invalid date string format");
        return null;
    }

    const datePart = dateTimeParts[0]; // YYYY-MM-DD
    const timePart = dateTimeParts[1]; // HH:MM:SS

    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = timePart.split(':');

    const date = new Date(
        parseInt(year, 10), 
        parseInt(month, 10) - 1, // JS months are 0-indexed
        parseInt(day, 10), 
        parseInt(hours, 10), 
        parseInt(minutes, 10), 
        parseInt(seconds, 10)
    );

    return date;
};
const ConvertForTimeLocal = (dateString, name) => {
    // console.log("timeString", dateString);

    if (!dateString) {
        console.log(`${name} is empty or invalid data`);
        return "";
    }

    // Split the date and time parts
    const [datePart, timePart] = dateString.split('T');

    if (!timePart) {
        console.log(`${name} does not have a valid time part`);
        return "";
    }

    // Parse the date part
    const [year, month, day] = datePart.split('-');
    
    // Parse the time part
    const [hour, minute, second] = timePart.split(':');
    let hour24 = parseInt(hour, 10);

    // Construct the Date object
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), hour24, parseInt(minute, 10), parseInt(second, 10));

    // Format the date string in the desired format
    const formattedDateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

    return formattedDateString;
};
function ApproveConfirmationForm({isOpen, 
    onClose, 
    handleApprove}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Approve!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to approve selected DTR?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleApprove}
                            style={{marginRight:"5px"}}>
                                APPROVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default MobileDTRApproval
